import { bool, func, node, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import IconRedeemRecipe from 'views/components/atoms/Icon/IconRedeemRecipe'
import TextWithIcon from 'views/components/molecules/TextWithIcon'

const ICONS_MAP = {
  'IconRedeemRecipe': <IconRedeemRecipe className="u-color--blue" />,
}

const OffCanvasNewItem = ({
  id,
  children,
  showItemArrow,
  icon,
  onClick,
  dataQaId,
}) => {
  return (
    <Button
      isReactControlled
      style="buttonGhost"
      onClick={onClick}
      className="o-OffCanvasNew__list-item"
      data-qa-id={dataQaId}
      name={id}
    >
      <div className="o-OffCanvasNew__list-item-text-wrapper">
        <TextWithIcon icon={ICONS_MAP[icon]}>{children}</TextWithIcon>
      </div>
      {showItemArrow && (
        <IconCaretRight className="u-margin-auto--left u-color--blue" />
      )}
    </Button>
  )
}

OffCanvasNewItem.propTypes = {
  children: node.isRequired,
  href: string,
  name: string,
  showItemArrow: bool,
  id: string,
  dataQaId: string,
  icon: string,
  onClick: func,
}

OffCanvasNewItem.defaultProps = {
  href: null,
  name: '',
  showItemArrow: false,
  id: '',
  icon: '',
}

export default OffCanvasNewItem
